@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
}

@if (showOwnProperty()) {
    <own-property></own-property>
}
@if (showSellingPrice()) {
    <selling-price></selling-price>
}
@if (showMortgageAmount()) {
    <mortgage-amount></mortgage-amount>
}
